import ReCAPTCHA from 'react-google-recaptcha'
import { connect } from 'react-redux'

import { getCaptchaId } from 'selectors/app'

const ReCaptcha = ({ captchaId, setNotRobot }) => {
  const onChange = value => {
    if (value !== null) {
      setNotRobot(true)
    } else {
      setNotRobot(false)
    }
  }

  return <ReCAPTCHA sitekey={captchaId} onChange={onChange} />
}

const mapStateToProps = state => ({
  captchaId: getCaptchaId(state),
})

export default connect(mapStateToProps)(ReCaptcha)
